import Joi from 'joi';
import mediaUrlSchema from '@utils/validate/blocksSchemes/mediaUrlSchema';
const productGalleryBlockSchema = Joi.object({
  type: Joi.string().valid('productGalleryBlock').required(),
  code: Joi.string().allow('', null).required(),
  slides: Joi.array().min(1).items(Joi.object({
    itemId: Joi.string().required(),
    image: Joi.object({
      image: mediaUrlSchema.allow('', null),
      blur: mediaUrlSchema.allow('', null)
    }),
    products: Joi.array().items(Joi.object().unknown(true))
  })),
  title: Joi.string().allow('', null).required(),
  scrollbar: Joi.bool().required()
}).unknown(true);
export default productGalleryBlockSchema;